module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-26.7864e5c8.png";